import Check from '@mui/icons-material/Check';
import { Button } from '@mui/material';
import React, { FunctionComponent } from 'react';

interface BulkSaveButtonProps {
  handleBulkSave: React.MouseEventHandler<HTMLButtonElement>;
  bulkSaveText: string;
  disabled?: boolean;
}

const BulkSaveButton: FunctionComponent<React.PropsWithChildren<BulkSaveButtonProps>> = ({
  handleBulkSave,
  bulkSaveText,
  disabled,
}) => {
  return (
    <Button disabled={disabled} onClick={handleBulkSave} color="primary" startIcon={<Check />} variant="contained">
      {bulkSaveText}
    </Button>
  );
};

export default BulkSaveButton;
